import styled from 'styled-components/macro';

export const Wrapper = styled.div<{ isTablet: boolean }>`
  box-sizing: border-box;
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${(props) => (props.isTablet ? '16px 32px' : '16px 16px')};
`;

export const RightSection = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
